// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export default function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        let context = this,
            args = arguments;
        let later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

//debouncing tiggered regularly for ongoing events like scrolling
//useful for cases like fade in animations for section when they appear on the screen
export function debounceOngoing(func, wait) {
    let timeout, context, args;
    return function() {
        //updating context and args
        //to execute the function with the input parameters from the latest call
        context = this;
        args = arguments;
        if (timeout) {
            return;
        }
        timeout = setTimeout(() => {
            timeout = false;
            func.apply(context, args);
        }, wait);
    };
}

//debounceOngoing test
// let testFunc = counter => {
//     console.log(`Executing with argument ${counter}`);
// };
// let testFuncD = debounceOngoing(testFunc, 1000);
// for (let i = 1; i <= 10; i++) {
//     setTimeout(() => {
//         testFuncD(i);
//     }, i * 100);
// }
